module.exports = __webpack_public_path__ + "img/stop_btn.98162cf8.png";